import SentinelAdapter from 'admin-panel/adapters/sentinel';

export default class SentinelUserAdapter extends SentinelAdapter {}

declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'sentinel/user': SentinelUserAdapter;
  }
}
